import { IAPIRoutes } from "../../../../config";

export const SalesRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const addSalesAckAPI: IAddSalesAckAPI = async ({ clinic_id, ...payload }) => {
    return POST(
      APIRoutes.apiAddSalesAck.replace("{clinic_id}", clinic_id.toString()),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };
  return {
    addSalesAckAPI,
  };
};
